/**
 * Get platform-specific labels and messages for virtual event platforms
 */
export const EVENT_PLATFORM = Object.freeze({
  ZOOM: 'zoom',
  GOOGLE_MEET: 'google_meet',
  MICROSOFT_TEAMS: 'microsoft_teams',
  YOUTUBE: 'youtube',
  HOPIN: 'hopin',
  VIMEO: 'vimeo',
  DISCORD: 'discord',
  OTHER: 'other',
});

/**
 * Get the display name for a platform
 * @param {string} platform - The platform key
 * @returns {string} The display name
 */
export function getPlatformDisplayName(platform) {
  switch (platform) {
    case EVENT_PLATFORM.ZOOM:
      return 'Zoom';
    case EVENT_PLATFORM.GOOGLE_MEET:
      return 'Google Meet';
    case EVENT_PLATFORM.MICROSOFT_TEAMS:
      return 'Microsoft Teams';
    case EVENT_PLATFORM.YOUTUBE:
      return 'YouTube';
    case EVENT_PLATFORM.HOPIN:
      return 'Hopin';
    case EVENT_PLATFORM.VIMEO:
      return 'Vimeo';
    case EVENT_PLATFORM.DISCORD:
      return 'Discord';
    case EVENT_PLATFORM.OTHER:
      return 'virtual meeting';
    default:
      return 'virtual meeting';
  }
}
